import { FacetDisplayNames } from '../facets/models'

export interface IFacet {
  id: string
  value: string
  displayName?: string
  count?: number
  subfacets?: ReadonlyArray<IFacet>
}

export type IQueryParams = any

export function mapFacetsObjectToInterface(
  facets: {
    [key: string]: ReadonlyArray<IFacet>
  },
  facetDisplayNames: FacetDisplayNames
): ReadonlyArray<IFacet> {
  return Object.keys(facets)
    .filter(key => !!key && !!facets[key])
    .map(key => ({
      id: key,
      value: key,
      displayName: facetDisplayNames[key] || key,
      count: facets[key].map(subfacet => subfacet.count || 0).reduce((total, count) => total + count, 0),
      subfacets: facets[key].map(subfacet => ({
        ...subfacet,
        id: key + subfacet.value
      }))
    }))
}

export function mapFacetUrlParamsToInterface(urlFacets: any): ReadonlyArray<IFacet> {
  return Object.keys(urlFacets)
    .map(key => ({
      id: key,
      value: key,
      subfacets: Array.isArray(urlFacets[key]) ? urlFacets[key] : [urlFacets[key]]
    }))
    .map(facet => ({
      ...facet,
      subfacets: facet.subfacets.map((subfacetName: string) => ({
        id: facet.value + subfacetName,
        value: subfacetName
      }))
    }))
}
